import { ThemeOptions, ThemeSkin } from '@wix/da-react-context/pkg/constants';

export const forceTheme = () => {
  return ThemeOptions.LIGHT;
};

export const forceThemeSkin = () => {
  return ThemeSkin.NONE;
};
